import ApprovalRequestList from './ApprovalRequestList.vue';

export { ApprovalRequestList };

export default {
  ApprovalRequestList,
};
